var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.305 10.165L11.865 15H9.057l-3.192-3.536L2.746 15H0l4.523-4.835L.218 5.603h2.77L5.986 8.91 9.01 5.603h2.649l-4.354 4.562zm6.234-3.269l1.879-1.306c.64-.416 1.062-.801 1.264-1.157.201-.356.302-.738.302-1.148 0-.669-.237-1.21-.71-1.62-.474-.411-1.097-.617-1.868-.617-.744 0-1.34.208-1.785.624-.447.416-.67 1.043-.67 1.881h1.436c0-.5.094-.846.281-1.038.188-.191.445-.287.772-.287s.585.097.777.292c.19.195.286.437.286.726 0 .29-.089.55-.266.785s-.67.628-1.479 1.184c-.691.477-1.627.927-1.908 1.35l.014 1.569H17V6.896h-3.461z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperscript);
export default __webpack_public_path__ + "static/media/superscript.94be4b620119a7ecd62b73ecf6342886.svg";
export { ForwardRef as ReactComponent };